import { Company } from '@/api/model/company'
import { BaseModel } from '@/api/base-model'
import { ReferralNodeAPI } from '@/api/backend-client'
import { ReferralNodeType } from '@/api/types'

export class ReferralNode extends BaseModel<ReferralNode> {
    protected collectionName = ReferralNodeAPI.collectionName

    constructor(
        public id: string,
        public type: ReferralNodeType,
        public source: Company|null,
        public target: Company|null,
        public excludedReferralFields: string[],
        public active: boolean,
    ) { super(id) }

    static fromData(data: any): ReferralNode {
        if (data === null || typeof data === 'string' || data instanceof ReferralNode) {
            return data
        }

        return new ReferralNode(
            data.id,
            data.type,
            data.source ? Company.fromData(data.source) : null,
            data.target ? Company.fromData(data.target) : null,
            data.excludedReferralFields || [],
            data.active,
        )
    }
}
